exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".redeem-container[data-v-15076b09]{display:inline-block;position:relative}.redeem-container .redeem-img[data-v-15076b09]{width:100%;height:auto}.redeem-container .close-btn[data-v-15076b09]{width:60px;height:60px;position:absolute;top:28px;right:-14px;cursor:pointer;z-index:2}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-15076b09","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/popup/Redeem.vue
// module id = 446
// module chunks = 0